var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2633_70254)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E81717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8858 15.8717L19.4102 12.6087H16.322V10.3363C16.322 9.404 16.6716 8.70479 18.07 8.70479H19.585V5.73316C18.7692 5.61663 17.8369 5.50009 17.0212 5.50009C14.3409 5.50009 12.4764 7.13158 12.4764 10.0449V12.6087H9.56299V15.8717H12.4764V24.0874C13.1173 24.2039 13.7582 24.2622 14.3992 24.2622C15.0401 24.2622 15.6811 24.2039 16.322 24.0874V15.8717H18.8858Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2633_70254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookRed);
export default __webpack_public_path__ + "static/media/facebook_red.5d961fc368a00ce9fff6164d51badbeb.svg";
export { ForwardRef as ReactComponent };